import axios from "axios";

const URL_AUTH = import.meta.env.VITE_AUTH_URL;

export const GetDocumentListByAgentService = (token, agentId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const documentList = await axios.get(
        `${URL_AUTH}/api/admin/v1/agent/${agentId}/document/list`,
        {
          headers: {
            "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
            Authorization: `Bearer ${token}`,
          }
        }
      );
      console.log("Doc List", documentList);
      resolve(documentList.data.data);
    } catch (error) {
      reject(error);
    }
  });
};